import { STATE } from '../constants/stateClasses';

const selectors = {
  container: '.js-product-img-container',
  product: '.js-product-img',
};

const addClass = (elem) => elem.classList.add(STATE.active);

const handleLazyLoadingProducts = () => {
  const containers = document.querySelectorAll(selectors.container);

  if (!containers.length) return;

  containers.forEach((container) => {
    const img = container.querySelector(selectors.product);

    if (img?.complete) {
      addClass(container);
    } else {
      img?.addEventListener('load', () => addClass(container));
    }
  });
};
export default handleLazyLoadingProducts;
